export class Repuesto {
    constructor(
        public id: number,
        public nombre: string,
        public descripcion: string,
        public eliminado: boolean,
        public imagen: string,
    ){}
    
}